import { Button } from "antd";

import ModalContainer from "../ModalContainer";

import styles from "./InformeUnificatModal.module.css";

const DESCRIPTION =
  "El document inclou el consolidat dels mòduls seleccionats. En confirmar, l'arxiu es descarregarà localment en el teu ordinador.";

interface InformeUnificatModalProps {
  open: boolean;
  onCancel: () => void;
  onDownload: () => void;
}

const InformeUnificatModal = ({
  open,
  onCancel,
  onDownload,
}: InformeUnificatModalProps) => {
  return (
    <ModalContainer
      open={open}
      centered
      onCancel={onCancel}
      width={520}
      className={styles.modal}
      styles={{
        mask: { backgroundColor: "#B5BAC299" },
      }}
    >
      <h3 className={styles.title}>Descàrrega d'informe unificat</h3>
      <p className={styles.description}>{DESCRIPTION}</p>
      <footer className={styles.footer}>
        <Button onClick={onCancel} type="default">
          Cancel·lar
        </Button>
        <Button onClick={onDownload} type="primary">
          Descarregar
        </Button>
      </footer>
    </ModalContainer>
  );
};

export default InformeUnificatModal;
